const DropLine = ({
  startPos = 100,
  duration = "10s",
}: {
  startPos: number;
  duration: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="100%"
      viewBox="0 0 20 800"
      fill="none"
    >
      {/* <path
        d="M10 800L10 0"
        stroke="rgba(255, 255, 255, 0.2)"
        stroke-width="2"
      /> */}

      <path d="M10 100L10 0" stroke="url(#paint0_linear)" strokeWidth="2">
        <animateTransform
          attributeName="transform"
          type="translate"
          from={`0,${startPos || 100}`}
          to="0,900"
          dur={duration}
          repeatCount="indefinite"
        />
      </path>

      <circle cx="10" cy="100" r="4" fill="white">
        <animate
          attributeName="cy"
          from={`${String(startPos + 100) || String(200)}`}
          to="1000"
          dur={duration}
          repeatCount="indefinite"
        />
      </circle>

      <defs>
        <linearGradient
          id="paint0_linear"
          x1="10"
          y1="0"
          x2="10"
          y2="100"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DropLine;
